import { render, staticRenderFns } from "./layer-item.vue?vue&type=template&id=7c0ae558&scoped=true&"
import script from "./layer-item.vue?vue&type=script&lang=js&"
export * from "./layer-item.vue?vue&type=script&lang=js&"
import style0 from "./layer-item.vue?vue&type=style&index=0&id=7c0ae558&scoped=true&lang=scss&"
import style1 from "./layer-item.vue?vue&type=style&index=1&id=7c0ae558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0ae558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VSlider})
